import React from 'react';

const figmaLogoDesktop = process.env.PUBLIC_URL + '/assets/figma-logo-desktop.svg';
const figmaLogoMobile = process.env.PUBLIC_URL + '/assets/figma-logo-mobile.svg';
const xLogo = process.env.PUBLIC_URL + '/assets/x-logo.svg';
const instagramLogo = process.env.PUBLIC_URL + '/assets/instagram-logo.svg';
const youtubeLogo = process.env.PUBLIC_URL + '/assets/youtube-logo.svg';
const linkedinLogo = process.env.PUBLIC_URL + '/assets/linkedin-logo.svg';

const Footer: React.FC = () => {
  const useCasesLinks = [
    'UI design',
    'UX design', 
    'Wireframing',
    'Diagramming',
    'Brainstorming',
    'Online whiteboard',
    'Team collaboration'
  ];

  const exploreLinks = [
    'Design',
    'Prototyping',
    'Development features',
    'Design systems',
    'Collaboration features',
    'Design process',
    'FigJam'
  ];

  const resourcesLinks = [
    'Blog',
    'Best practices',
    'Colors',
    'Color wheel',
    'Support',
    'Developers',
    'Resource library'
  ];

  return (
    <>
      {/* Desktop Footer - exact Figma layout */}
      <footer className="hidden desktop:block bg-background-default border-t border-border-default w-full">
        <div className="w-device-desktop mx-auto px-800 pt-800 pb-4000">
          <div className="flex flex-wrap gap-400 items-start">
            {/* Logo and Social Links - Title */}
            <div className="flex flex-col gap-600 items-start min-w-[240px] w-[262px]">
              <img 
                src={figmaLogoDesktop} 
                alt="Figma Logo" 
                className="h-[35px] w-[23.333px]"
              />
              <div className="flex gap-400 items-center">
                <a href="#" className="hover:opacity-70 transition-opacity">
                  <img src={xLogo} alt="X Logo" className="h-[24px] w-[23.98px]" />
                </a>
                <a href="#" className="hover:opacity-70 transition-opacity">
                  <img src={instagramLogo} alt="Instagram Logo" className="h-[24px] w-[24px]" />
                </a>
                <a href="#" className="hover:opacity-70 transition-opacity">
                  <img src={youtubeLogo} alt="YouTube Logo" className="h-[24px] w-[24px]" />
                </a>
                <a href="#" className="hover:opacity-70 transition-opacity">
                  <img src={linkedinLogo} alt="LinkedIn Logo" className="h-[24px] w-[24px]" />
                </a>
              </div>
            </div>

            {/* Use Cases - Text Link List */}
            <div className="flex flex-col gap-300 items-start w-[262px]">
              <div className="flex flex-col gap-[10px] items-start pb-400 pt-0 px-0 box-border w-full">
                <div className="flex items-start w-full">
                  <p className="text-[16px] font-semibold text-text-default leading-[1.4]">
                    Use cases
                  </p>
                </div>
              </div>
              {useCasesLinks.map((link, index) => (
                <div key={index} className="h-[22px] relative w-[89px]">
                  <div className="absolute bottom-0 left-0 right-[26.97%] top-0 flex flex-col justify-center leading-[0]">
                    <p className="text-[16px] font-regular text-text-default leading-[1.4] whitespace-nowrap">
                      {link}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Explore - Text Link List */}
            <div className="flex flex-col gap-300 items-start w-[262px]">
              <div className="flex flex-col gap-[10px] items-start pb-400 pt-0 px-0 box-border w-full">
                <div className="flex items-start w-full">
                  <p className="text-[16px] font-semibold text-text-default leading-[1.4]">
                    Explore
                  </p>
                </div>
              </div>
              {exploreLinks.map((link, index) => (
                <div key={index} className="h-[22px] relative w-[89px]">
                  <div className="absolute bottom-0 left-0 right-[26.97%] top-0 flex flex-col justify-center leading-[0]">
                    <p className="text-[16px] font-regular text-text-default leading-[1.4] whitespace-nowrap">
                      {link}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Resources - Text Link List */}
            <div className="flex flex-col gap-300 items-start w-[262px]">
              <div className="flex flex-col gap-[10px] items-start pb-400 pt-0 px-0 box-border w-full">
                <div className="flex items-start w-full">
                  <p className="text-[16px] font-semibold text-text-default leading-[1.4]">
                    Resources
                  </p>
                </div>
              </div>
              {resourcesLinks.map((link, index) => (
                <div key={index} className="h-[22px] relative w-[89px]">
                  <div className="absolute bottom-0 left-0 right-[26.97%] top-0 flex flex-col justify-center leading-[0]">
                    <p className="text-[16px] font-regular text-text-default leading-[1.4] whitespace-nowrap">
                      {link}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </footer>

      {/* Mobile Footer - exact Figma layout */}
      <footer className="block desktop:hidden bg-background-default border-t border-border-default w-full">
        <div className="px-800 py-800 box-border">
          <div className="flex flex-col gap-1600 items-start">
            {/* Logo and Social Links - Title */}
            <div className="flex items-center justify-between min-w-[240px] w-full">
              <img 
                src={figmaLogoMobile} 
                alt="Figma Logo" 
                className="h-[35px] w-[23.333px]"
              />
              <div className="flex gap-400 items-center">
                <a href="#" className="hover:opacity-70 transition-opacity">
                  <img src={xLogo} alt="X Logo" className="h-[24px] w-[23.98px]" />
                </a>
                <a href="#" className="hover:opacity-70 transition-opacity">
                  <img src={instagramLogo} alt="Instagram Logo" className="h-[24px] w-[24px]" />
                </a>
                <a href="#" className="hover:opacity-70 transition-opacity">
                  <img src={youtubeLogo} alt="YouTube Logo" className="h-[24px] w-[24px]" />
                </a>
                <a href="#" className="hover:opacity-70 transition-opacity">
                  <img src={linkedinLogo} alt="LinkedIn Logo" className="h-[24px] w-[24px]" />
                </a>
              </div>
            </div>

            {/* Links */}
            <div className="flex flex-col gap-600 items-start w-full">
              {/* Use Cases - Text Link List */}
              <div className="flex flex-col gap-200 items-start w-full">
                <div className="flex flex-col gap-[10px] items-start pb-100 pt-0 px-0 box-border w-full">
                  <div className="flex items-start w-full">
                    <p className="text-[16px] font-bold text-text-default leading-[1.4]">
                      Use cases
                    </p>
                  </div>
                </div>
                {useCasesLinks.map((link, index) => (
                  <div key={index} className="h-[22px] relative w-full">
                    <div className="absolute bottom-0 left-0 right-[26.97%] top-0 flex flex-col justify-center leading-[0]">
                      <p className="text-[16px] font-regular text-text-default leading-[1.4] whitespace-nowrap">
                        {link}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Explore - Text Link List */}
              <div className="flex flex-col gap-200 items-start w-full">
                <div className="flex flex-col gap-[10px] items-start pb-100 pt-0 px-0 box-border w-full">
                  <div className="flex items-start w-full">
                    <p className="text-[16px] font-bold text-text-default leading-[1.4]">
                      Explore
                    </p>
                  </div>
                </div>
                {exploreLinks.map((link, index) => (
                  <div key={index} className="h-[22px] relative w-full">
                    <div className="absolute bottom-0 left-0 right-[26.97%] top-0 flex flex-col justify-center leading-[0]">
                      <p className="text-[16px] font-regular text-text-default leading-[1.4] whitespace-nowrap">
                        {link}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Resources - Text Link List */}
              <div className="flex flex-col gap-200 items-start w-full">
                <div className="flex flex-col gap-[10px] items-start pb-100 pt-0 px-0 box-border w-full">
                  <div className="flex items-start w-full">
                    <p className="text-[16px] font-bold text-text-default leading-[1.4]">
                      Resources
                    </p>
                  </div>
                </div>
                {resourcesLinks.map((link, index) => (
                  <div key={index} className="h-[22px] relative w-full">
                    <div className="absolute bottom-0 left-0 right-[26.97%] top-0 flex flex-col justify-center leading-[0]">
                      <p className="text-[16px] font-regular text-text-default leading-[1.4] whitespace-nowrap">
                        {link}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;

